export default __webpack_public_path__ + "static/media/configuration.e70d7610.svg";